import React from 'react';
import { CloseIcon } from 'tuui';
import { pxToRem } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { MOTION_PARAM_OPTIONS } from '../consts/motionParamsConsts';
import { useMotionParams } from '../hooks/useMotionParams';
import styles from './motionParamTag.module.scss';

export const MotionParamTag = ({ category, option }) => {
    const { clearMotionParamsFormField } = useMotionParams();

    const options = MOTION_PARAM_OPTIONS[category] || [];
    const selectedOption = options.find(opt => opt.value === option);
    const messageId = selectedOption?.messageId;

    return (
        <div className={styles['tag']}>
            <FormattedMessage id={messageId} />
            <span
                className={styles['delete-icon']}
                onClick={() => {
                    clearMotionParamsFormField(category);
                }}
            >
                <CloseIcon sx={{ fontSize: pxToRem('10px') }} />
            </span>
        </div>
    );
};
